import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { ConfigProvider } from './contexts/ConfigContext'
import MuiThemeSync from './components/ui/MuiThemeSync'
import GlobalErrorToast from './components/ui/GlobalErrorToast'
import reportError, {
  installGlobalErrorHandlers
} from './utils/errorReporter'
import { installModuleLoadRecovery } from './utils/moduleLoadRecovery'
import { clearLegacyDashboardServiceWorker } from './utils/serviceWorker'
import { I18nProvider } from './contexts/I18nContext'
import './index.css'

// Install global error handlers for production error reporting
installGlobalErrorHandlers()
installModuleLoadRecovery({
  onBeforeReload: error =>
    reportError({
      message: `Recovering from module load failure: ${error?.message || String(error)}`,
      stack: error?.stack
    })
})

const renderDashboard = () => {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <BrowserRouter>
        <ThemeProvider>
          <MuiThemeSync>
            <ConfigProvider>
              <AuthProvider>
                <I18nProvider>
                  <App />
                  <GlobalErrorToast />
                  <Toaster
                    position="top-right"
                    toastOptions={{
                      duration: 4000,
                      style: {
                        background: '#363636',
                        color: '#fff',
                      },
                      success: {
                        style: {
                          background: '#10b981',
                        },
                      },
                      error: {
                        style: {
                          background: '#ef4444',
                        },
                      },
                      ariaProps: {
                        role: 'status',
                        'aria-live': 'polite',
                      },
                    }}
                  />
                </I18nProvider>
              </AuthProvider>
            </ConfigProvider>
          </MuiThemeSync>
        </ThemeProvider>
      </BrowserRouter>
    </React.StrictMode>,
  )
}

const startDashboard = async () => {
  try {
    const reloadRequested = await clearLegacyDashboardServiceWorker()
    if (reloadRequested) return
  } catch {
    // Legacy worker cleanup is best-effort and must not block the dashboard.
  }

  renderDashboard()
}

startDashboard()
